import { DEFAULT_WAVE_COLOR } from './../../constants/colors';
import { Webinar } from './../../api/modules/hosting/types';
import { AccessData, Landing, LandingCTAProps } from '@anm/api/modules/hosting';
import { DEFAULT_HAS_FOOTER, DEFAULT_THEME } from '@anm/constants/videoLandings';
import getLandingTemplate from '@anm/helpers/getLandingTemplate';
import isEmpty from '@anm/helpers/is/isEmpty';
import { VideoSizes } from '@anm/hosting-player';
import { getWebinarColorsByTheme } from '@anm/styles/landingThemeStyles';

export const omitEmpty = (value: any) => typeof value === 'object' && value !== null && isEmpty(value);

const defaultCTAState: LandingCTAProps = {
  disabled: true,
  buttonText: '',
  buttonLink: ''
};

const defaultAccessState: AccessData = {
  nameEmail: false,
  password: null,
  passwordHash: null,
  granted: true
};

const getlandingWithDefaults = <T extends Landing | Webinar>(landing: T, sizes?: VideoSizes): T => {
  const isWebinar = !!(landing as Webinar).parameters?.streamId;
  const theme = landing.parameters?.theme || DEFAULT_THEME;

  return {
    ...landing,
    template: getLandingTemplate(landing.template, sizes),
    parameters: {
      cta: {
        ...defaultCTAState,
        ...landing.parameters?.cta
      },
      ...(isWebinar && {
        access: {
          ...defaultAccessState,
          ...landing.parameters?.access
        },
        chat: true,
        showOnDemand: true,
        showCommentsOnDemand: false,
        playerColor: landing.parameters?.playerColor || getWebinarColorsByTheme(theme).playerColor || DEFAULT_WAVE_COLOR
      }),
      theme,
      logoUrl: '',
      isEmbedded: false,
      hasFooter: DEFAULT_HAS_FOOTER,
      ...landing.parameters
    }
  };
};

export default getlandingWithDefaults;
